<div class="px-plus mt-mega">
  <div class="d-flex align-items-center gap-pony">
    <span class="t-4">سلام{{ name() ? '، ' + name() : '' }}!</span>
    <span class="fs-36">👋</span>
  </div>
  <span class="text-onback-medium b-2">همه‌ی کار‌های مهم مالی انجام شدن! می‌تونی از خدمات زیر استفاده کنی.</span>
</div>
